export default "__VITE_ASSET__CUqF1tY$__"